import * as React from 'react';

import type { NodeType } from '@gitbook/slate';
import type { EditorContainer } from '@gitbook/slate-react';
import type { OverlayTriggerState } from '@gitbook/spine-react';
import { usePrevious } from '@gitbook/util-react-hooks';

/**
 * Hook to restore focus to an editor node when a previously open overlay is closed.
 * Useful for popovers that edit inline or block nodes.
 */
export function useRestoreFocusFromPopover(
    trigger: OverlayTriggerState,
    editor: EditorContainer,
    node: NodeType
) {
    const { isOpen } = trigger;
    const previousIsOpen = usePrevious(isOpen);
    // We do this in a useEffect to ensure it's done after the popover is unmounted.
    React.useEffect(() => {
        const popoverHasClosed = previousIsOpen && !isOpen;
        if (popoverHasClosed) {
            editor.change((change) => {
                change.collapseToStartOf(node);
                change.focus();
            });
        }
    }, [previousIsOpen, isOpen, editor, node]);
}
